<template>
  <div v-if="!chartsReady " class="wait-wrapper">
    <div id="loading-visualization"><div class="lds-ring"><div /><div /><div /><div /></div></div>
  </div>
  <div v-else-if="chartsReady && Object.keys(multiChartsData).length > 0" class="charts-container scrollbar">
    <template
      v-for="row in multiChartsData"
      :key="row.name"
    >
      <div v-if="row && row.length > 0" class="chart-row">
        <div v-for="chart in row" :key="chart.name" class="chart-fixed">
          <ValidatorChartMulti
            class="chart"
            :name="`Validate Session ${chart.id}`"
            :data="chart.apex"
          />
        </div>
      </div>
    </template>
  </div>
  <template v-else-if="chartsReady && Object.keys(singleChartsData).length > 0">
    <div class="chart-wrapper scrollbar">
      <div v-for="chart in singleChartsData" :key="chart.name" class="chart-small">
        <ValidatorChartSingle
          class="chart"
          :name="chart.id"
          :data="chart.apex"
        />
      </div>
    </div>
  </template>
  <div v-else-if="chartsReady && Object.keys(multiChartsData).length === 0 && Object.keys(singleChartsData).length === 0" id="wrapper" class="chart-wrapper scrollbar">
    <span class="warning-text">No validation metrics to display</span>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import ValidatorChartSingle from '@/components/TrainerComponent/TrainerExperimentAndSessions/ValidatorChartSingle.vue';
import { useToast } from 'vue-toast-notification';
import ValidatorChartMulti from '@/components/TrainerComponent/TrainerExperimentAndSessions/ValidatorChartMulti.vue';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();
export default {
  name: 'ValidatorCharts',
  components: {
    ValidatorChartSingle,
    ValidatorChartMulti,
  },
  props: {
    sessionIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dataConnect: new DatastoreConnect(),
      chartsReady: false,
      multiChartsData: {},
      singleChartsData: {},
      controller: null,
      isMultiSession: false,
    };
  },
  computed: {
  },
  mounted() {
    this.interval = setInterval(() => {
      this.fetchCharts(this.sessionIds);
    }, 10000);

    this.fetchCharts(this.sessionIds);
  },
  unmounted() {
    this.controller.abort();
    clearInterval(this.interval);
  },
  methods: {
    async fetchCharts(session_ids) {
      this.controller = new AbortController();
      const currentController = this.controller;
      // Get Training Charts from BE
      const params = {
        session_ids,
      };

      const resp = await this.dataConnect.getValidateGraphs(params, currentController.signal)
        .catch((error) => {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Failed to retrieve metrics: ${error}`,
            type: "error",
            position: "top",
          });
        });
      if (!resp || resp.error || !resp.result) {
        $toast.open({
          queue: true,
          dismissible: true,
          message: `Failed to retrieve metrics: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        this.chartsData = {};
        this.chartsReady = true;
        return;
      }

      let N = 0;
      for (const [key, value] of Object.entries(resp.result)) {
        N = Math.max(value.length, N);
        if (N > 1) {
          this.isMultiSession = true;
          break;
        }
      }

      if (this.isMultiSession) {
        this.multiChartsData = resp.result;
      } else {
        // reformat single session
        const formattedChartsData = {};
        for (const [key, value] of Object.entries(resp.result)) {
          if (value.length > 0) {
            formattedChartsData[key] = value[0];
          }
        }
        this.singleChartsData = formattedChartsData;
      }
      this.chartsReady = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 8px;
  background-color: #f4f3f2;
  align-content: start;
  overflow-y: auto;
}

.charts-container{
  overflow: auto;
}

.chart-row {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px;
  align-content: start;
}

.wait-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 4px;
}

.chart-fixed{
  border-radius: 8px;
  min-width: 600px;
  max-width: 600px;
  height: fit-content;
  background-color: white;
  flex-grow: 1;

  margin: 8px;
}

.chart-small{
  border-radius: 8px;
  width: 600px;
  min-width: 400px;
  background-color: white;
  flex-grow: 1;

  margin: 8px;
}

.chart{
  border: 4px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);

}

.warning-text{
  font-size: 0.9rem;
}

</style>
